import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const adminLinks = [
  { path: '/sirri_api/men_images_form', label: 'Images Form' },
  { path: '/sirri_api/mensdashboard', label: 'Men Dashboard' },
  { path: '/sirri_api/mensmessagingdashboard', label: 'Messaging Dashboard' },
  { path: '/sirri_api/mensignup.html', label: 'Men Signup' },
  { path: '/sirri_api/schedule_messages', label: 'Schedule messages' },
  { path: '/sirri_api/perfil_generador', label: 'Profile Generator' },
  { path: '/sirri_api/activations', label: 'Activations' },
  { path: '/sirri_api/archived_profiles', label: 'Archived Profiles' },
  { path: '/sirri_api/deleted_profiles', label: 'Deleted Profiles' },
  { path: '/sirri_api/womeninfo', label: 'Women Info' },
  { path: '/sirri_api/addauth', label: 'Add Auth' },
  { path: '/sirri_api/support_chats', label: 'Support Chats' },
  { path: '/sirri_api/financial_dashboard', label: 'Financial Dashboard' },
  { path: '/sirri_api/ads', label: 'Ads', fullPage: true },
  { path: '/sirri_api/ads_data', label: 'Ads Data' },
  { path: '/sirri_api/bridge_stats', label: 'Bridge Stats' },
  { path: '/sirri_api/assessment_events', label: 'Assessment Events' },
  { path: '/sirri_api/maintenance', label: 'Maintenance' },
  { path: '/sirri_api/homepage_intro_video', label: 'Homepage Intro Video' },
  { path: '/sirri_api/testimonials', label: 'Testimonials' },
  { path: '/sirri_api/logout_everyone', label: 'Logout Everyone' },
  { path: '/sirri_api/chats', label: 'All Chats' },
  { path: '/sirri_api/scheduled_jobs', label: 'Scheduled Jobs' },
  { path: '/sirri_api/message_tasks', label: 'Message Tasks' },
  { path: '/sirri_api/bulk_package_change', label: 'Mens utils' },
  { path: '/sirri_api/hubby_drafts', label: 'Hubby Drafts' },
  { path: '/sirri_api/confirmed_hubby_drafts', label: 'Confirmed Hubby Drafts' },
  { path: '/sirri_api/ai_conversations', label: 'AI Conversations' },
  { path: '/sirri_api/notifications', label: 'Notifications' }
];

export default function AdminLayout({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative min-h-screen">
      <button
        className="m-2 p-2 bg-primary text-white"
        onClick={() => setOpen(true)}
      >
        Show Menu
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-40 flex bg-black bg-opacity-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-primary text-white w-64 p-4 space-y-2 overflow-y-auto max-h-screen"
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              exit={{ x: '-100%' }}
              transition={{ type: 'tween', duration: 0.3 }}
            >
              <button
                className="mb-4 px-2 py-1 bg-secondary text-white rounded"
                onClick={() => setOpen(false)}
              >
                Close
              </button>
              {adminLinks.map(link => link.fullPage ? (
                <a
                  key={link.path}
                  href={link.path}
                  onClick={() => setOpen(false)}
                  className="block hover:bg-secondary px-2 py-1 rounded text-white no-underline"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setOpen(false)}
                  className="block hover:bg-secondary px-2 py-1 rounded text-white no-underline"
                >
                  {link.label}
                </Link>
              ))}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="p-4">
        {children}
      </div>
    </div>
  );
}
